import React from "react";

const ScrolToTop = () => {
    const handleButtonClick = () => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth",
          });
    };

    return (
        <button className="scroltop" onClick={handleButtonClick}><span className="fa fa-angle-up  relative" id="btn-vibrate" /></button>
    );
};

export default ScrolToTop;
